<div [formGroup]="form" *ngIf="form != null">
  <div class="row">
    <div class="col-12 col-md-3">
      <p class="form-text">Do you want to run this report by Month or Quarter?</p>
    </div>
    <div class="col-12 col-md-2">
      <input
        type="radio"
        id="radio-month"
        name="reportType"
        formControlName="reportType"
        [value]="types.Month" />
      <label for="radio-month" title="Month"><span></span>Month</label>
    </div>
    <div class="col-12 col-md-2">
      <input
        type="radio"
        id="radio-quarter"
        name="reportType"
        formControlName="reportType"
        [value]="types.Quarter" />
      <label for="radio-quarter" title="Quarter"><span></span>Quarter</label>
    </div>
  </div>
  <ng-container *ngIf="reportType === types.Month">
    <div class="row">
      <div class="col-12 col-md-2">
        <p class="form-text">Select Month/Year</p>
      </div>
      <div class="col-12 col-md-10">
        <lib-month-picker formControlName="month"></lib-month-picker>
      </div>
    </div>
    <div class="row mt-3">
      <div class="col-12">
        <lib-checkbox
          [size]="checkSizes.Small"
          formControlName="monthQuarterTotals"
          [label]="
            'Report will display with month/year totals. Check this box if you want the report to instead display by month/quarter totals.'
          "></lib-checkbox>
      </div>
    </div>
  </ng-container>
  <ng-container *ngIf="reportType === types.Quarter">
    <div class="row">
      <div class="col-12 col-md-2">
        <p class="form-text">Select Year/Quarter</p>
      </div>
      <div class="col-12 col-md-10">
        <lib-quarter-picker formControlName="quarter"></lib-quarter-picker>
      </div>
    </div>
  </ng-container>

  <div class="row mt-3">
    <div class="col-12">
      <lib-report-buttons
        *ngIf="form != null"
        [disabled]="form.invalid"
        (generateReport)="generateReport()"
        (downloadReport)="downloadReport($event)"></lib-report-buttons>
    </div>
  </div>
</div>
